import { checkPermission } from "@/utils/auth";
export const checkAuth ={
    computed:{
        isEmployee(){
            return checkPermission(['EMPLOYEE'])
        }
    }
}